import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DataTablesResponse } from '../models/datatables';

@Injectable({
  providedIn: 'root'
})

export class RenaultManagerDistributorFileLoadService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultManagerDistributorFileLoad/";

  constructor(private http: HttpClient) { }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  } 
}
